import React, { useState } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { HelpCircle } from 'lucide-react';
import { faqs } from '../../mock';

const FAQ = () => {
  return (
    <section id="faq" className="py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 reveal">
          <div className="h-11 w-11 rounded-full grid place-items-center bg-[var(--brand-green)] text-[var(--brand-cream)] mb-5">
            <HelpCircle size={18} strokeWidth={1.6} />
          </div>
          <div className="text-xs uppercase tracking-[0.24em] text-[var(--brand-gold)] mb-4">Frequently asked</div>
          <h2 className="font-serif text-4xl lg:text-5xl text-green tracking-tight leading-[1.05]">
            Things worth <em className="italic">knowing</em> before you book.
          </h2>
          <p className="mt-5 text-[var(--brand-mute)] max-w-md">
            If your question isn’t answered here, reception is happy to talk it through with you.
          </p>
        </div>

        <div className="lg:col-span-7 reveal">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="rounded-2xl border border-[rgba(31,58,46,0.1)] bg-[var(--brand-cream-2)] px-6 data-[state=open]:border-[rgba(31,58,46,0.25)]"
              >
                <AccordionTrigger className="font-serif text-left text-lg lg:text-xl text-green hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-relaxed text-[var(--brand-ink)] pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
